<template>
    	<div class="register">
        <v-header :goBackal='true' :register='true'></v-header>
			  <span class="title" v-show="false">{{$t('emailproving.register')}}</span>
			<div class="pro_pic" v-show="false">
				<img src="../../../static/img/dp-logo.jpg" alt=" "/>
			</div>
			<!--选择手机或者邮箱注册-->
			<div class="select_register" style="padding:0px 20px;justify-content:space-between;display: flex;margin-top:20px;">
				<el-button type="button" class="re_phone" :class="{'bg':bgphone}" @click="re_phone"><span>{{$t('register.registerphone')}}</span></el-button>
				<el-button type="button" class="re_email" :class="{'bg':bgemail}" @click="re_email"><span>{{$t('register.registeremail')}}</span></el-button>
			</div>
			<registerphone v-show="bgphone"></registerphone>
			<registeremail v-show="bgemail"></registeremail>
	</div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import registerphone from '../../components/registerphone';
import registeremail from '../../components/registeremail';
import header from '../../components/header';
export default {
name: "register",
data() {
	return {
		bgphone:true,
		bgemail:false,

	};
  },
  components:{
  	"registerphone":registerphone,
  	"registeremail":registeremail,
    "v-header":header
  },
  methods: {
	//选择手机或者邮箱注册
	re_phone(){
		this.bgphone=true;
		this.bgemail=false;
	},
	re_email(){
		this.bgemail=true;
		this.bgphone=false;
	}
  }
}
</script>
<style scoped>
.title{
  text-align: center;
  font-size: .75rem;
  display: block;
  color: #828282;
}
.logo{
	text-align: center;
	width: 50%;
	margin: 0 auto;
	margin-top: 8px;
}
.logo img{
	width: 100%;
}
.pro_pic{
	width: 100%;
	text-align: center;
	margin: 1rem 0;
}

.el-input {
	margin-top: 10px;
}

.over {
	margin-left: 35%;
}

.change {
	width: 80px;
}

a {
	color: white;
}

.get {
	width: 110px;
}

.yanzheng {
	width: 165px;
}

.danger {
	font-size: 0.625rem;
  margin-top: 5px;
  color: red;
}

.list {
	width: 250px;
}

/*手机或者邮箱注册*/
.re_phone,.re_email{
	width: 50%;
  height: 2.6rem;
  line-height: 2.6rem;
  padding: 0 0;
	border: 0px;
	background: transparent;
	border-radius: 0;
	font-size: 1rem;
}
.bg span{
	color: #7dc3f2;
	border-bottom: 1px solid#7dc3f2;
	padding-bottom: 5px;
}
</style>


// WEBPACK FOOTER //
// src/m_page/login/register.vue